import { apiCall } from "./authServices";

export const addSupportTicket = async (payload) => {
  try {
    const response = await apiCall({
      endpoint: "api/support/add-tickets",
      method: "POST",
      payload: payload,
    });
    return response;
  } catch (error) {
    console.error("Error adding support ticket:", error);
    throw error;
  }
};

export const getAllSupportTickets = async () => {
  try {
    const response = await apiCall({
      endpoint: "api/support/get-all-tickets",
      method: "GET",
    });
    return response;
  } catch (error) {
    console.error("Error fetching support tickets:", error);
    throw error;
  }
};

export const reopenSupportTicket = async (payload) => {
  try {
    const response = await apiCall({
      endpoint: "api/support/reopen-ticket",
      method: "PUT", // Ensure the method matches the backend's requirement
      payload: payload, // Ensure the payload contains the correct structure
    });
    return response;
  } catch (error) {
    console.error("Error reopening support ticket:", error);
    throw error;
  }
};

export const getSupportTicketBarGraphData = async (payload) => {
  try {
    const response = await apiCall({
      endpoint: "api/support/get-support-ticket-stats-graph",
      method: "POST",
      payload: payload,
    });
    return response;
  } catch (error) {
    console.error("Error adding support ticket:", error);
    throw error;
  }
};

export const getAllSupportTicketsAdmin = async (payload) => {
  try {
    const response = await apiCall({
      endpoint: "api/support/get-all-tickets-admin",
      method: "POST",
      payload: payload, // Pass the selected month as the parameter
    });
    return response;
  } catch (error) {
    console.error("Error fetching admin support tickets:", error);
    throw error;
  }
};

export const resolvePendingTicket = async (payload) => {
  try {
    const response = await apiCall({
      endpoint: "api/support/resolve-pending-ticket",
      method: "PUT",
      payload: payload, // Ensure the payload is passed correctly
    });
    return response;
  } catch (error) {
    console.error("Error resolving pending ticket:", error);
    throw error;
  }
};

export const getSupportTicketPieChartData = async () => {
  try {
    const response = await apiCall({
      endpoint: "api/support/get-support-ticket-stats-pie",
      method: "GET",
    });
    return response;
  } catch (error) {
    console.error("Error fetching pie chart data:", error);
    throw error;
  }
};